import gql from 'graphql-tag';

const PLANTING_EVENT_AGGREGATES_ARD = gql`
  query PLANTING_EVENT_AGGREGATES_ARD($fieldId: ID!) {
    field(id: $fieldId) {
      id
      plantingEventAggregates {
        eventsByCropSeason(backendMachineDataSource: "COMBINED") {
          crop {
            id
            name
          }
          seasonName
          seasonYear
          plantedArea { u v }
          averageSeedingRate { u v }
          seedProductEvents {
            seedProduct {
              id
              name
            }
            plantedArea { u v }
            averageSeedingRate { u v }
            firstPlantedDateTime
            lastPlantedDateTime
            source
          }
        }
      }
    }
  }`;

export interface PlantingQueryVariables {
  fieldId: string;
}

export const getPlantingQuery = (variables: PlantingQueryVariables) => ({
  query: PLANTING_EVENT_AGGREGATES_ARD,
  variables,
})
